import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { AppLanguages } from 'src/app/core/models/models';
import { AuthFactoryService } from '../authFactory.service';
import { IAuthStatusToken } from '../models/authStatusToken.model';
import { PlatformIntegration } from 'src/app/integrations/models/platform-integration.enum';
import { environment } from 'src/environments/environment';
import { ENVIRONMENT } from 'src/app/core/enums/enums';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authFactoryService: AuthFactoryService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return this.authFactoryService.getSesionStatusToken().pipe(
      map((status) => {
        const parsedStatusToken: IAuthStatusToken = {
          isAuthenticated: status[0],
          accessToken: status[1]
        };

        if (parsedStatusToken.isAuthenticated) {
          this.authFactoryService.dispatchSaveToken(parsedStatusToken.accessToken);
          let lang = AppLanguages.english;

          if (environment.name !== ENVIRONMENT.develop) {
            switch (this.authFactoryService.getCurrentPlatform()) {
              case PlatformIntegration.salesforce:
                lang = AppLanguages.spanishMexican;
                break;

              case PlatformIntegration.default:
                lang =
                  this.parseJwt(parsedStatusToken.accessToken)?.client_lang || AppLanguages.spanish;
                break;
            }
          }

          this.authFactoryService.dispatchSaveLang(lang);
          this.translateService.use(lang);
          return true;
        }
        return this.router.parseUrl('/unauthorized');
      })
    );
  }
}
